import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";

import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {createRequestParams} from "common/hook/create-request-params/createRequestParams";
import {GetSummaryTableResponse} from "features/model/types/hr/getSummaryTable";
import {
    setSummaryTableData,
    setSummaryTableFilters,
} from "features/model/slice/hr/summary-table/summaryTableSlice";
import {RootState} from "app/store";


interface GetSummaryTableParams {
    from?: string;
    to?: string;
    page?: number;
    includeEnded?: boolean;
}


export const getSummaryTable = createAsyncThunk(
    "hr/getSummaryTable",
    async ({  from, to, page, includeEnded }: GetSummaryTableParams, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const { token } = JSON.parse(authToken);

            const state = thunkAPI.getState() as RootState;
            const filters = state.summaryTable.filters;
            const resolvedFrom = from !== undefined ? from : filters.from;
            const resolvedTo = to !== undefined ? to : filters.to;
            const resolvedPage = page !== undefined ? page : 0;
            const resolvedIncludeEnded = includeEnded !== undefined ? includeEnded : filters.includeEnded;

            thunkAPI.dispatch(setSummaryTableFilters({
                from: resolvedFrom || '',
                to: resolvedTo || '',
                includeEnded: !!resolvedIncludeEnded,
            }));

            const params = createRequestParams(
                resolvedFrom,
                resolvedTo,
                resolvedPage,
                undefined,
                resolvedIncludeEnded,
            );

            const response = await axios.get<GetSummaryTableResponse>(
                `/api/pivot-table`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params,
                }
            );

            if (response.data && response.data.success) {
                thunkAPI.dispatch(setSummaryTableData(response.data.data));
            }

            return response.data;
        } catch (e) {
            return thunkAPI.rejectWithValue("error");
        }
    }
);
